import { Link } from "@tanstack/react-router";
import { Sparkles, X } from "lucide-react";
import { useTranslation } from "react-i18next";

export const firstAnswerNoteKey = (userId: string) => `inquira:first-answer-note:${userId}`;

/** Small, inline, non-blocking note shown once after a Free student's first successful answer. */
export function FirstAnswerPremiumNote({ onDismiss }: { onDismiss: () => void }) {
  const { t } = useTranslation();
  return (
    <div role="status" className="relative mt-4 rounded-xl border border-neon-blue/20 bg-neon-blue/5 p-4 pr-10 text-sm text-ink">
      <button onClick={onDismiss} aria-label={t("monetization.dismiss")} className="absolute right-1 top-1 flex size-11 items-center justify-center text-ink-muted hover:text-ink">
        <X className="size-4" />
      </button>
      <p className="flex items-center gap-2 font-semibold">
        <Sparkles className="size-4 text-neon-pink" aria-hidden="true" /> {t("monetization.first_answer_title")}
      </p>
      <p className="mt-1 text-xs leading-relaxed text-ink-muted">{t("monetization.first_answer_body")}</p>
      <Link to="/pricing" className="mt-2 inline-block text-xs font-semibold text-neon-pink underline">
        {t("monetization.compare_premium_plans")}
      </Link>
    </div>
  );
}
